import script from "./UploadPermissionsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadPermissionsModal.vue?vue&type=script&setup=true&lang=js"

import "./UploadPermissionsModal.vue?vue&type=style&index=0&id=67b0b248&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67b0b248"]])

export default __exports__